<template>
    <div>
        <b-modal
            id="blockEssay"
            title="Problema na Redação"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <b-form @submit.stop.prevent="submit">

                    <!-- Field -->
                    <b-form-group
                        label="Motivo da Devolução"
                        description="Descreva brevemente o motivo da devolução desta redação. Essa informação será mostrada para o aluno no email enviado pelo sistema.">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.block_message"
                            placeholder="Escreva a mensagem para o aluno neste espaço ..."
                            :state="hasErrors('block_message', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="block_message" />
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disable="loading">
                        Devolver Redação
                    </b-button>
                </b-form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['essayId'],
    data() {
        return {
            loading: false,
            errors: {},
            essay: null,
            form: {
                block_message: null,
            }
        }
    },

    created() {
        this.$root.$on('blockEssay', function(essay) {
            this.essay = essay
            this.$bvModal.show('blockEssay')
        })
    },

    methods: {
        submit() {
            this.loading = true;
            axios.put('/teacher/essays/' + this.essayId + '/block', this.form)
                .then((result) => {

                    // Reload
                    window.location.reload();

                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
